import fwuClientService from './fwuClientService';
import {MW_ERRORS} from '../../consts/app/mwErrors';
import {createError} from '../errors/errorService';
import {log} from '../log';
import server from '../server/server';
import {FWU_ERROR_CODES} from '../../consts/fwu/fwuErrorCodes';
import converter from '../../utils/converter';

let fwuPackage = undefined;

const clearPackageData = () => {
    fwuPackage = null;
};

const downloadFwuPackage = async ({fwuTarget, downloadUrl}) => {
    try {
        if (fwuPackage) return true;

        await downloadFirmware(downloadUrl);
        log.info(`FWUService: FWU package for fwuTarget: ${fwuTarget} has been downloaded successfully`);
    } catch (e) {
        log.error(`FWUService: FWU package downloading is failed for fwuTarget: ${fwuTarget}, ${e}`);

        throw e;
    }
};

const downloadFirmware = async (downloadUrl) => {
    // const firmwareData = selectMwDeviceFirmwareData(getState());
    // const firmwareTarget = fwuTargetService.getIotTargetByFwuTarget(firmwareData, fwuTarget);

    if (!downloadUrl) throw createError(MW_ERRORS.ERROR_FWU_DOWNLOAD_URL_EMPTY, 'downloadUrl is empty');

    try {
        const res = await server.get(downloadUrl);
        fwuPackage = res.data;
    } catch (e) {
        throw createError(
            MW_ERRORS.ERROR_FWU_DOWNLOAD_OR_PARSE,
            e.message || 'Failed to download or parse firmware package'
        );
    }
};

const startFwUpdate = async ({fwuTarget, onFwuError, onFwuStatusEvent, onFwuFinish, package_index}) => {
    //TODO: IA
    // const fwuTarget = selectFirmwareFwuTarget(getState());

    if (fwuPackage) {
        log.info(`FWUService: start FWU update process. fwuTarget: ${fwuTarget}`);

        const FwuClient = fwuClientService.getFwuClient(fwuTarget);
        const fwuClient = new FwuClient({
            fwuTarget,
            fwuPackageData: fwuPackage,
            onFwuError,
            onFwuFinish,
            onFwuStatusEvent,
        });

        fwuClient.startFwUpdate(package_index);
    } else {
        onFwuError?.({errorCode: FWU_ERROR_CODES.START_NOT_FOUND_DATA, fwuTarget});
        log.info(`FWUService: startFwUpdate error, package is not loaded. fwuTarget: ${fwuTarget}`);
    }
};

const getFwUpdateFinishAfterRebootEvent = () => fwuPackage?.reboot_after_fwu_message;

const convertHexIndexToInt = (hex) => {
    const hexIndexReversed = hex
        .match(/.{1,2}/g)
        .reverse()
        .join('');
    const index = converter.hex2dec(hexIndexReversed);

    return parseInt(index);
};

const isFWUAvailable = (type) => {
    // if (!type) return false;
    // const isUsb = connectivityService.isUsb();
    // const isUsbFWUAvailable = appConfig.getIsUsbFWUAvailable(type);
    // const isBleFWUAvailable = appConfig.getIsBleFWUAvailable(type);
    // const isAnyFWUAvailable = isUsbFWUAvailable || isBleFWUAvailable;
    // return isUsb ? isUsbFWUAvailable : isAnyFWUAvailable;
};

const initiateUpdateFirmwareMessage = (target) => {
    // const fwuInfo = fwuPackageService.getFwuInfoByFwuTargetStatic(target);
    // const version = fwuInfo?.availableFirmwares ? fwuInfo?.availableFirmwares[0]?.version : undefined;
    // // hide some modals from background (e.g. reset failed)
    // modalService.hideModal(ModalTypes.FWU_ERROR);
    // appRouterService.forwardToUpdateFWPage({
    //     target,
    //     version,
    //     isSblFirmware: fwuInfo?.isSblFirmware,
    // });
};

const getIsBackgroundFwuCheckEnabled = () => {
    // const isBackgroundFwuCheckEnabled =
    //     appConfig.getIsBackgroundFwuCheckEnabled() && tncService.isAggregatedSettingEnabled(ENABLE_FW_UPDATES_CHECK);
    // return isBackgroundFwuCheckEnabled;
};

const onFwuSuccess = () => {
    // log.info('End firmware process. Success notification is displayed.');
    // dispatch(setNotificationSuccess(getLocalizedStrings()[localizationKeys.FIRMWARE_UPDATE_SUCCESS]));
    // dispatch(setFWUSuccess());
};

export default {
    clearPackageData,
    convertHexIndexToInt,
    downloadFirmware,
    downloadFwuPackage,
    getFwUpdateFinishAfterRebootEvent,
    getIsBackgroundFwuCheckEnabled,
    initiateUpdateFirmwareMessage,
    isFWUAvailable,
    onFwuSuccess,
    startFwUpdate,
};
